var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d59bfadb6c32686cf3f0654b7a1fa5b8.js').default;export default
        Object.assign({}, scope_0 )
    